/* KAZIPAWS: native Shopify Ajax cart flow. No manual analytics events. */
(function () {
  'use strict';
  if (window.__kpCartFlow || !window.fetch || !window.FormData) return;
  window.__kpCartFlow = true;
  var pending = new WeakSet();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartURL = root + 'cart';

  function notice(owner, text, showCart) {
    var box = owner.nextElementSibling;
    if (!box || !box.classList.contains('kp-cart-status')) {
      box = document.createElement('div');
      box.className = 'kp-cart-status';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      box.setAttribute('aria-atomic', 'true');
      box.style.cssText = 'margin-top:10px;font-size:14px;line-height:1.5;flex-basis:100%;color:inherit';
      owner.insertAdjacentElement('afterend', box);
    }
    box.textContent = text;
    if (showCart) {
      var link = document.createElement('a');
      link.href = cartURL;
      link.textContent = 'View cart';
      link.style.cssText = 'color:inherit;text-decoration:underline;font-weight:700';
      box.appendChild(document.createTextNode(' '));
      box.appendChild(link);
    }
  }

  async function refreshCount() {
    try {
      var response = await fetch(cartURL + '.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      var cart = await response.json();
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('.cart-btn').forEach(function (el) {
        el.setAttribute('aria-label', 'Cart (' + cart.item_count + ')');
      });
      document.querySelectorAll('.mobile-menu a[href="' + cartURL + '"]').forEach(function (el) {
        Array.from(el.childNodes).forEach(function (node) {
          if (node.nodeType === 3 && /Cart\s*\(/.test(node.textContent)) {
            node.textContent = 'Cart (' + cart.item_count + ')';
          }
        });
      });
    } catch (_) { /* Addition succeeded; never retry the POST for a badge failure. */ }
  }

  async function add(owner, control, body) {
    if (pending.has(owner)) return;
    pending.add(owner);
    var busy = control.getAttribute('aria-busy');
    control.setAttribute('aria-busy', 'true');
    notice(owner, 'Adding to cart...', false);
    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: body
      });
      if (!response.ok) {
        var error = await response.json().catch(function () { return {}; });
        notice(owner, typeof error.description === 'string' ? error.description : 'Could not add this item. Please check availability.', true);
        return;
      }
      // Shopify's existing integration observes this successful Ajax request.
      // Staying on the page avoids interrupting its native event delivery.
      notice(owner, 'Added to cart.', true);
      await refreshCount();
    } catch (_) {
      // A dropped response can still mean the cart changed. Never resubmit.
      notice(owner, 'We could not confirm the addition. Check your cart before trying again.', true);
    } finally {
      pending.delete(owner);
      if (busy === null) control.removeAttribute('aria-busy');
      else control.setAttribute('aria-busy', busy);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement) ||
        !form.matches('form[id^="product-form-"]')) return;
    var action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    var body = new FormData(form);
    // Leave unselected/invalid variants to the existing theme validation.
    if (!/^\d+$/.test(String(body.get('id') || '')) || !form.checkValidity()) return;
    var button = event.submitter || form.querySelector('[type="submit"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    body.delete('return_to');
    add(form, button, body);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/cart\/add\/?$/.test(url.pathname) ||
        !/^\d+$/.test(url.searchParams.get('id') || '')) return;
    // Only the existing single-item card links, not bundle/app payloads.
    if (Array.from(url.searchParams.keys()).some(function (key) {
      return ['id', 'quantity', 'return_to'].indexOf(key) === -1;
    })) return;
    event.preventDefault();
    var body = new FormData();
    body.set('id', url.searchParams.get('id'));
    body.set('quantity', url.searchParams.get('quantity') || '1');
    add(link, link, body);
  }, true);
}());
